import { useEffect } from 'react'
import { setUserVars } from '@mortgage-pos/ui/utils/fullStory'
import { useStoreActions } from '@mortgage-pos/ui/store'
import { Routes, QuestionSetSlug, CookieName } from '@mortgage-pos/types'
import { deleteCookie, getCookie, getDomain } from '@mortgage-pos/utils'
import { useNavigate } from 'react-router-dom'

export const useQuestionnaireInit = () => {
  const navigate = useNavigate()

  const { setApplicationGuid, setApplicationId } = useStoreActions(
    (state) => state.application
  )
  const {
    setFBLeadId,
    getQuestionnaire,
    setBankrateLeadId,
    setDirectMailerOfferCode,
    resetQuestionnaire,
  } = useStoreActions((state) => state.questionnaire)

  useEffect(() => {
    async function fetchQuestionnaire(questionSet) {
      try {
        // Clear any previous questionnaire state before fetching a new one
        // This helps prevent state inconsistencies during navigation
        resetQuestionnaire()
        await getQuestionnaire(questionSet || QuestionSetSlug.NTL)
      } catch {
        return navigate(`/${Routes.APP_1003}/error`)
      }
    }

    const urlParams = new URLSearchParams(window.location.search)

    const bankrateLeadIdParam = urlParams.get('bankrate-lead-id')
    if (bankrateLeadIdParam) {
      setBankrateLeadId(bankrateLeadIdParam)
    }

    let applicationGuid = urlParams.get('application-guid')

    const appGuidCookie = getCookie(CookieName.AppGuid)
    if (!applicationGuid && appGuidCookie) {
      urlParams.set('application-guid', appGuidCookie)
      deleteCookie(CookieName.AppGuid, getDomain())

      applicationGuid = appGuidCookie
    }

    if (applicationGuid) setApplicationGuid(applicationGuid)

    const applicationId = parseInt(urlParams.get('application-id'))
    if (applicationId) setApplicationId(applicationId)

    const fBLeadIdParam = urlParams.get('fbclid')
    if (fBLeadIdParam) setFBLeadId(fBLeadIdParam)

    const directMailerOfferCode = urlParams.get('offer-code')
    if (directMailerOfferCode) {
      setDirectMailerOfferCode(
        directMailerOfferCode.substring(0, 8).toUpperCase()
      )
    }

    const questionSet = urlParams.get('question-set')

    fetchQuestionnaire(questionSet)

    window['_fs_ready'] = () => {
      setUserVars({
        bankrateLeadId_str: bankrateLeadIdParam,
        FBLeadId_str: fBLeadIdParam,
        questionSet_str: questionSet,
      })
    }
  }, [])
}

export default useQuestionnaireInit
